/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

import Label from '../formsUi/common/label/Label';
import PhoneInput from '../formsUi/phoneInput/PhoneInput';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormPhoneInputControls = ({
    labelName,
    name,
    onChange,
    onValidation,
    dataField,
    error,
    formSetting,
    fieldSetting,
    overRideProps,
    onBlur,
    ...inputProps
}) => {

    const debouncedOnChange = useCallback(
        debounce((dataField, value) => {
            onChange(dataField, value);
        },
            fieldSetting?.debounceTime ? fieldSetting?.debounceTime : 10
        ), // Adjust the delay as needed 
        [onChange]);

    const handleInputChange = (value) => {
        if (onChange) {
            debouncedOnChange(dataField, value);
        }
    };

    const handleOnBlur = () => {
        onBlur(dataField);
    };

    return (
        <div className="input-field-sec phone-input">
            {inputProps.hasMainTitle && (
                <div className="section-title">
                    <h5>{inputProps.hasMainTitle}</h5>
                </div>
            )}
            <div className="input-label-part">
                {labelName && <Label labelName={labelName} htmlFor={name} isRequired={inputProps.isRequired} fieldSetting={fieldSetting} />}
                <PhoneInput
                    {...inputProps}
                    name={name}
                    onChange={handleInputChange}
                    onBlur={handleOnBlur}
                    isDisable={
                        formSetting?.isViewOnly ||
                        inputProps?.isDisable ||
                        overRideProps?.isDisable ||
                        fieldSetting?.isDisable
                    }
                    isMasked={fieldSetting?.isMasked}
                    maskedType={fieldSetting?.maskedType}
                    defaultCountry={fieldSetting?.defaultCountry}
                />
            </div>
            <ValidationMessage error={error || ""} />
        </div>
    );
};

FormPhoneInputControls.propTypes = {
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onValidation: PropTypes.func,
    dataField: PropTypes.string.isRequired,
    error: PropTypes.string,
    formSetting: PropTypes.shape({
        isViewOnly: PropTypes.bool,
    }),
    fieldSetting: PropTypes.shape({
        defaultCountry: PropTypes.string,
        debounceTime: PropTypes.number
    }),
    overRideProps: PropTypes.shape({
        isDisable: PropTypes.bool,
    }),
    inputProps: PropTypes.shape({
        hasMainTitle: PropTypes.string,
        isDisable: PropTypes.bool,
    }),
};

export default FormPhoneInputControls;
